export default {
  "content": "<rect x=\".5\" width=\"40\" height=\"40\" rx=\"20\" fill=\"#EFFAFD\"/><g clip-path=\"url(#clip0_15_2791)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.978 26.924a.823.823 0 001.093-.402l1.976-4.28 1.635 1.634a.823.823 0 001.33-.237l1.892-4.1 1.643 2.19a.823.823 0 001.44-.233l2.47-7.412a.824.824 0 00-1.562-.52l-1.973 5.92-1.528-2.037a.824.824 0 00-1.407.15l-1.975 4.28-1.636-1.635a.824.824 0 00-1.33.237l-2.47 5.352a.824.824 0 00.402 1.093z\" fill=\"#028EB7\"/></g><defs><clipPath id=\"clip0_15_2791\"><path fill=\"#fff\" transform=\"translate(12.5 12)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "41",
    "height": "40",
    "viewBox": "0 0 41 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};